import React from 'react';

export type ConfigItem = {
  key: string;
  title: React.ReactNode;
  configurable?: boolean;
  children?: ConfigItem[];
};

export const sortConfig = (tableConfig: ConfigItem[], order: string[]) => [...tableConfig].sort((a, b) => {
  const indexA = order.indexOf(a.key);
  const indexB = order.indexOf(b.key);

  if (indexA === -1 || indexB === -1) {
    return 1;
  }

  if (indexA > indexB) {
    return 1;
  }

  if (indexB > indexA) {
    return -1;
  }

  return 0;
});

const filterItemBySearch = (item: ConfigItem, search: string) => (
  (typeof item.title === 'string' ? item.title : '')
    .toLowerCase()
    .search(search.toLowerCase()) !== -1
);

export const filterConfigurable = (config: ConfigItem[]): ConfigItem[] => config
  .filter((item) => item.configurable !== false)
  .map((item) => {
    if (item.children) {
      return {
        ...item,
        children: item.children.filter((childItem) => childItem.configurable !== false),
      };
    }

    return item;
  });

export const filterBySearch = (config: ConfigItem[], search: string): ConfigItem[] => config
  .map((item) => {
    if (item.children) {
      return {
        ...item,
        children: item.children.filter((childItem) => filterItemBySearch(item, search)
                            || filterItemBySearch(childItem, search)),
      };
    }

    return item;
  })
  .filter((item) => filterItemBySearch(item, search) || item.children?.length);
